import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbTypeahead, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { Airport } from '../../models/airport';

@Component({
    selector: 'emt-station-selector',
    templateUrl: './station-selector.component.html',
    styleUrls: ['./station-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgbTypeahead, NgbHighlight],
})
export class StationSelectorComponent {
  @Input() airports: Airport[];
  @ViewChild('instance') instance: NgbTypeahead;
  public focus$ = new Subject<string>();
  public click$ = new Subject<string>();

  constructor(private router: Router) {}

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term =>
        (term === ''
          ? this.airports
          : this.airports.filter((v: { airportCode: string }) => v.airportCode.toLowerCase().indexOf(term.toLowerCase()) > -1)
        ).slice(0, 10)
      )
    );
  };

  formatter = (x: { airportCode: string }) => x.airportCode;

  selectedItem(selection: { item: Airport; preventDefault: Function }) {
    const featureModule = this.router.url.split('/')[1];
    if (featureModule) {
      // triggers route to new station selection with param flag to replace the current active tab
      this.router.navigate([`${featureModule}/${selection.item.airportCode.toUpperCase()}`], {
        queryParams: { replaceActiveTab: true },
        queryParamsHandling: 'merge',
      });

      // Deleting user selection and typed input. Using an ngModel or formControl doesn't allow you to clear it with this ngb-typeahead component
      selection.preventDefault();
      this.instance.writeValue(null);
    }
  }
}
